export const INTERNAL_TRANSFER_TYPE_PERMISSION = {
  VIEW: 'INTERNAL_TRANSFER_TYPE_VIEW',
  ADD: 'INTERNAL_TRANSFER_TYPE_ADD',
  EDIT: 'INTERNAL_TRANSFER_TYPE_EDIT',
  DEL: 'INTERNAL_TRANSFER_TYPE_DEL',
};
